import useCheckoutState from '../../../hooks/useCheckoutState';
import useMountEffect from '../../../hooks/useMountEffect';
import normalizePhoneNumber from '../../../lib/normalizePhoneNumber';
import {
  getPhoneFieldCountries,
  getPhoneFieldDefaultCountry,
} from '../../../lib/phoneFieldCountries';

export default function HiddenPhoneField({ field, onChange }) {
  const { countryCode } = useCheckoutState();

  useMountEffect(() => {
    if (!field.value) return;
    let active = true;

    // Not intl-tel-input/utils: that would ship the number rules in a second chunk
    import('intl-tel-input/reactWithUtils').then(({ intlTelInput }) => {
      const normalized = normalizePhoneNumber(
        field.value,
        getPhoneFieldDefaultCountry(
          getPhoneFieldCountries(field.limitAllowedCountries),
          countryCode,
        ),
        intlTelInput.utils,
      );
      if (active && normalized !== field.value) onChange(normalized);
    });

    return () => {
      active = false;
    };
  });

  return null;
}
